// Sample data for the dashboard charts and stats

export const monthlyData = {
  current: 24,
  percentChange: 12,
  trend: [
    { date: "Jan", value: 10 },
    { date: "Feb", value: 15 },
    { date: "Mar", value: 24 },
  ],
}

export const performanceData = {
  efficiency: 92,
  trend: [
    { date: "Jan", value: 85 },
    { date: "Feb", value: 88 },
    { date: "Mar", value: 92 },
  ],
}

export const inspectionStats = {
  total: 156,
  completed: 142,
  pending: 14,
  byType: [
    { type: "Routine", count: 98 },
    { type: "Follow-up", count: 32 },
    { type: "Complaint", count: 26 },
  ],
}

export const timeStats = {
  averageTime: 2.25, // hours
  totalHours: 351,
  byDay: [
    { day: "Mon", hours: 8.5 },
    { day: "Tue", hours: 9.2 },
    { day: "Wed", hours: 7.8 },
    { day: "Thu", hours: 8.1 },
    { day: "Fri", hours: 6.5 },
  ],
}